// extracted by mini-css-extract-plugin
export var blogPostTemplateAuthorTile = "blog-post-module--blog-post-template-author-tile--b68e6";
export var blogPostTemplateAuthorTile__img = "blog-post-module--blog-post-template-author-tile__img--9ff22";
export var blogPostTemplateAuthorTile__imgLink = "blog-post-module--blog-post-template-author-tile__img-link--04995";
export var blogPostTemplateAuthorTile__link = "blog-post-module--blog-post-template-author-tile__link--524dc";
export var blogPostTemplateAuthorTile__linkSocial = "blog-post-module--blog-post-template-author-tile__link--social--7eb34";
export var blogPostTemplate__authorPosts = "blog-post-module--blog-post-template__author-posts--934e2";
export var blogPostTemplate__authorPosts__headline = "blog-post-module--blog-post-template__author-posts__headline--b66d1";
export var blogPostTemplate__authorPosts__tiles = "blog-post-module--blog-post-template__author-posts__tiles--0dd44";
export var blogPostTemplate__more = "blog-post-module--blog-post-template__more--4968f";
export var blogPostTemplate__more__cardImage = "blog-post-module--blog-post-template__more__card-image--50b8e";
export var blogPostTemplate__share = "blog-post-module--blog-post-template__share--73d19";
export var grid = "blog-post-module--grid--b9b63";
export var gridWithRowGap = "blog-post-module--grid--with-row-gap--44d4d";
export var maxWidthContainer = "blog-post-module--max-width-container--2a980";
export var mt0 = "blog-post-module--mt-0--82e18";
export var mt1 = "blog-post-module--mt-1--1c0ad";
export var mt2 = "blog-post-module--mt-2--085fb";
export var mt3 = "blog-post-module--mt-3--19491";
export var mt4 = "blog-post-module--mt-4--38324";
export var mt5 = "blog-post-module--mt-5--a3278";
export var mt6 = "blog-post-module--mt-6--1efbb";
export var removeVisuallyHidden = "blog-post-module--remove-visually-hidden--27b72";
export var visuallyHidden = "blog-post-module--visually-hidden--1a5ed";
export var widgetBase = "blog-post-module--widget-base--b02ab";